exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indicator {\r\n    /* min-width: 129px; */\r\n    border-radius: 15px;\r\n    padding: 2px 10px 2px 1px;\r\n    /* background-color: #ECEBEB; */\r\n    background-color: #FCD34D;\r\n    /* color: #6E6E6E; */\r\n    color: #2B2D45;\r\nfont-weight: 800;\r\nwidth: 90px;\r\nheight: 20px;\r\nfont-size: 12px;\r\n}\r\n\r\n.indicator-complete {\r\n    /* background-color: #D5F4E6; */\r\n    background-color: #86EFAC;\r\n    width: 83px;\r\n    /* color: #00AC57 */\r\n    color: #2B2D45;\r\n}\r\n\r\n.icon-display{\r\n    /* transform: scale(0.65); */\r\n    -webkit-transform: scale(0.5);\r\n            transform: scale(0.5);\r\n    \r\n    font-weight: 800;\r\n    margin-right: -2px !important;\r\n}\r\nbutton > span > .mat-icon\r\n{\r\n    font-size: xx-large;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/indicator/indicator.component.css
// module id = ../../../../../src/app/components/indicator/indicator.component.css
// module chunks = main